import ReanimatedModuleCompat from './ReanimatedModuleCompat';
export default ReanimatedModuleCompat;
